import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "gatsby";

const useStyle = makeStyles((theme) => ({
  sliderContainer: {
    position: "relative",
    minHeight: "80vh",
    maxHeight: "90vh",
    backgroundSize: "cover",
    backgroundPosition: "50%",
  },
  sliderInfo: {
    width: "50%",
    textAlign: "left",
    paddingLeft: 70,
    position: "absolute",
    bottom: 100,
    [theme.breakpoints.down("xs")]: {
      paddingLeft: 10,
    },
    [theme.breakpoints.down("sm")]: {
      width: "90%",
      bottom: 20,
      paddingLeft: 40,
    },
  },
  sliderTitle: {
    fontFamily: "SportingGrotesque",
    fontWeight: "normal",
    fontSize: "1.5em",
  },
  sliderInfo_a: {
    fontFamily: "SportingGrotesque",
    fontWeight: 700,
    fontSize: 42,
    lineHeight: 1.24,
    color: "#fff !important",
    textDecoration: "none !important",
    textShadow: "-1px 0 5px rgba(0,0,0,0.5)",
    [theme.breakpoints.down("sm")]: {
      fontSize: 24,
    },
  },
  sliderInfo_span: {
    fontFamily: "Lato",
    fontWeight: 700,
    fontSize: 18,
    lineHeight: "normal",
    color: "#fff !important",
    textDecoration: "none !important",
    textShadow: "-1px 0 3px rgba(0,0,0,0.5)",
    opacity: 0.6,
  },
}));

export default function SliderItem({ data }) {
  const classes = useStyle();
  return (
    <div
      className={classes.sliderContainer}
      style={{
        backgroundImage: `url(${data?.featuredImage?.node?.mediaItemUrl})`,
      }}
    >
      <div className={classes.sliderInfo}>
        <h2 className={classes.sliderTitle}>
          <Link
            className={classes.sliderInfo_a}
            to={data?.uri}
            title={data?.title}
          >
            {data?.title}
          </Link>
        </h2>
        <span className={classes.sliderInfo_span}>
          by{" "}
          <span style={{ marginLeft: 5, marginRight: 5 }}>
            {data?.author?.node?.name}
          </span>{" "}
          |{" "}
          <span style={{ marginLeft: 5 }}>
            {data?.categories?.nodes[0]?.name}
          </span>
        </span>
      </div>
    </div>
  );
}
